import { render, staticRenderFns } from "./OrderInList.vue?vue&type=template&id=3f3ea30d&scoped=true"
import script from "./OrderInList.vue?vue&type=script&lang=js"
export * from "./OrderInList.vue?vue&type=script&lang=js"
import style0 from "./OrderInList.vue?vue&type=style&index=0&id=3f3ea30d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ea30d",
  null
  
)

export default component.exports